import styled from 'styled-components';

import { PaletteColor } from '@utils/types';

export const StyledListingItemTimeZone = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: row;
    gap: 3px;
  }
`;

export const TimeZoneLocationLabel = styled.span<{ textColor: PaletteColor }>`
  font-size: 14px;
  color: ${({ theme, textColor }) => theme.palette[textColor]};
  opacity: ${({ textColor }) => (textColor === 'black' ? '0.6' : '1')};
  font-weight: 400;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
  }
`;
